import * as React from 'react';
import * as Modal from 'react-modal';

import {Icon} from '../util';
import * as editorIcon from '../images/editorIcon.png';

interface Props {
	showAsModal: boolean;
	isOpen?: boolean;
	onClose?(): void;
}

const QUESTIONS_EMAIL = 'support@socotra.com';

const EDITOR_ICON_WIDTH = 50;

export default class HelpModal extends React.Component<Props, {}> {

	public render() {
		if (this.props.showAsModal) {
			return <Modal
				isOpen={this.props.isOpen}
				onRequestClose={this.props.onClose}
				contentLabel='editor-help-modal'
			>
				{this.renderContent()}
			</Modal>;
		} else {
			return this.renderContent();
		}
	}

	private renderContent() {
		return <div className='intro-text'>
			<a className='close-button' onClick={this.props.onClose}>
				<Icon name='close' />
			</a>
			{this.renderEditorIcon()}
			<hr className='application-icon-rule'/>
			<ul className='list-socotra-green'>
				<li>Configuration Editor is for evaluation purposes only. When you begin
					extended configuration work, please contact us for production-ready tools.</li>
				<li>Your configuration is stored in your browser, so save to disk often.</li>
				<li>For questions or concerns, please contact us at:</li>
			</ul>
			{this.renderEmailLink()}
		</div>;
	}

	private renderEditorIcon() {
		return <div className='application-icon-container'>
			<img src={editorIcon} width={EDITOR_ICON_WIDTH} />
			<h2 className='bolder'>Configuration Editor</h2>
		</div>;
	}

	private renderEmailLink() {
		return <p className='align-center'>
			<a className='button' href={`mailto:${QUESTIONS_EMAIL}`} target='_blank'>
				{QUESTIONS_EMAIL}
			</a>
		</p>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/EditorHelp.tsx